import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { motion, LayoutGroup } from 'framer-motion';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logoUrl = "https://ondftutsbyhfpczwipjv.supabase.co/storage/v1/object/public/SOUNDCHECKPRO/SOUNDCHECKPRO%20logo.PNG";
  
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="fixed top-0 w-full z-50 bg-studio-dark/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 h-24 flex items-center justify-between">
        <div className="flex items-center cursor-pointer h-16" onClick={() => navigate('/')}>
          <img src={logoUrl} alt="SOUNDCHECKPRO Logo" className="h-full w-auto object-contain" />
        </div>

        <nav className="hidden lg:flex items-center gap-2">
          <LayoutGroup>
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path || 
                              (link.path !== '/' && location.pathname.startsWith(link.path));
              
              return (
                <NavLink
                  key={link.name}
                  to={link.path}
                  className="relative px-4 py-2 text-sm font-medium tracking-wide transition-colors group"
                >
                  <span className={`relative z-10 transition-colors duration-300 ${
                    isActive ? 'text-white' : 'text-gray-500 group-hover:text-gray-300'
                  }`}>
                    {link.name}
                  </span>
                  
                  {isActive && (
                    <motion.div
                      layoutId="nav-active"
                      className="absolute inset-x-0 -bottom-[31px] h-[2px] bg-electric-blue shadow-[0_0_10px_#00D1FF]"
                      transition={{
                        type: "spring",
                        stiffness: 380,
                        damping: 30
                      }}
                    />
                  )}
                  
                  {/* Subtle hover indicator */}
                  {!isActive && (
                    <div className="absolute inset-x-0 -bottom-[31px] h-[2px] bg-white/0 group-hover:bg-white/10 transition-colors" />
                  )}
                </NavLink>
              );
            })}
          </LayoutGroup>
        </nav>

        <button
          onClick={() => navigate('/booking')}
          className="bg-electric-blue hover:bg-electric-blue-hover text-studio-dark font-bold px-8 py-3 rounded-full text-sm tracking-wide transition-all shadow-glow hover:shadow-glow-strong active:scale-95"
        >
          BOOK NOW
        </button>
      </div>
    </header>
  );
};

export default Header;